import * as React from 'react'
import { useLoaderData } from 'react-router-dom'

import { Button } from 'sdk/button/Button'
import { Content } from 'sdk/components'
import { ContactUs } from 'sdk/contact-us/ContactUs'

import { Hero } from './sections/hero/Hero'
import { VisionSection } from './sections/vision/VisionSection'
import { OurStorySection } from './sections/our-story/OurStorySection'
import { LeadershipTeamSection } from './sections/leadership-team/LeadershipTeamSection'
import { NewsSection } from './sections/news/NewsSection'

import styles from './AboutPage.module.scss'

import type { AboutPageLoaderData } from './interfaces'

const isExternalUrl = (url: string): boolean => /^(https?:\/\/|mailto:|tel:)/.test(url)

export const AboutPage: React.FC = () => {
  const { newsfeed, cmsContent } = useLoaderData() as AboutPageLoaderData

  if (!cmsContent) {
    throw new Error('About CMS content missing')
  }

  const isExternalContactUrl = isExternalUrl(cmsContent.contact.buttonUrl)

  return (
    <>
      <Hero content={cmsContent.hero} />
      <Content gap={150}>
        <VisionSection content={cmsContent.vision} />
        <OurStorySection content={cmsContent.ourStory} />
        <LeadershipTeamSection content={cmsContent.leadership} />
        <NewsSection newsfeed={newsfeed} />
        <div className={styles.contactSection}>
          <ContactUs
            text={cmsContent.contact.text}
            button={(
              <Button
                as={isExternalContactUrl ? 'link' : 'router-link'}
                href={isExternalContactUrl ? cmsContent.contact.buttonUrl : undefined}
                to={!isExternalContactUrl ? cmsContent.contact.buttonUrl : undefined}
                target={isExternalContactUrl ? '_blank' : undefined}
              >
                {cmsContent.contact.buttonText}
              </Button>
            )}
          />
        </div>
      </Content>
    </>
  )
}
